// extracted by mini-css-extract-plugin
module.exports = {"subheading":"SelectedPipes_subheading__JC8Qb","productHeading":"SelectedPipes_productHeading__2pyRL"};